<div class="dialog-content" role="dialog" aria-labelledby="dialogTitle">
    <div class="dialog-header">
        <h2 class="title" id="dialogTitle">
            <img src="assets/icons/warning-icon.svg" alt="" /> {{ config.data.title }}
        </h2>
        <div>
            <button pRipple class="close-icon" [pAutoFocus]="true" aria-label="Dialog schliessen" (click)="closeDialog()">
                <img src="assets/icons/close-icon.svg" alt="Dialog schliessen" />
            </button>
        </div>
    </div>
    <div class="information-text">
        Selektion enthält gesperrtes Material. Bestellung nur mit spezieller Erlaubnis über den Bild/Videodesk möglich
    </div>
    <div class="dialog-footer">
        <button class="search-button" type="button" (click)="accept()" pRipple>
            <img src="assets/icons/check-icon.svg" alt="" />Ok
        </button>
        <button
            class="dialog-secondary-button"
            type="button"
            pButton
            icon="pi pi-times"
            (click)="closeDialog()"
            label="Abbrechen"
        ></button>
    </div>
</div>
